export class Customer {
  id: string = "";
  firstname: string = "";
  lastname: string = "";
  phone: string = "";
  email: string = "";
  referenceId: string = "";
  unit: string = "";
}
